import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [MatCheckboxModule, MatButtonModule, MatCardModule, MatFormFieldModule, MatInputModule],
  exports: [MatCheckboxModule, MatButtonModule, MatCardModule, MatFormFieldModule, MatInputModule]
})
export class MaterialModule {}
